<script lang="ts">
  import * as Store from '@/store';
  import {isMobile} from '@/store';
  import {project} from '@/store';
  import Swal from 'sweetalert2';
  import type {Video} from '@/types/project';
  import {MENU, STEP} from '@/types/common';
  import {tooltip} from '@/actions/tippy-action';
  import {beta} from '@/lib/beta/beta';

  export let quote: string;

  $: {
    const parser = new DOMParser();
    const doc = parser.parseFromString(quote, 'text/html');
    quote = doc.body.textContent || '';
  }
  // export let verse: string;

  export let selectedVideo: Video | null;
  function createNewClip() {
    if (!selectedVideo) return;
    Store.thumbnail.reset();
    Store.prompt.resetState();
    Store.menu.set(MENU.THUMBNAILS);
    Store.thumbDraft.createNewDraft($project);

    Store.subtitles.set({items: {raw: [], grouped: []}});

    Swal.fire({
      titleText: 'Info',
      text: 'Loading Thumbnail please wait...',
      icon: 'info',
      cancelButtonText: 'Cancel',
      didOpen: () => Swal.showLoading(),
      allowOutsideClick: () => !Swal.isLoading(),
      allowEnterKey: () => !Swal.isLoading(),
      allowEscapeKey: () => !Swal.isLoading()
    });

    Store.thumbnail
      .getVideo(selectedVideo.id)
      .then(() => {
        Store.thumbnail.selectVideo(selectedVideo);
        Store.thumbnail.set({
          template: null,
          isNew: true,
          isUpdated: false,
          quote: quote,
          type: 'quote'
        });
        Swal.close();
        Store.step.update(STEP.CHOOSE_TEMPLATE);
      })
      .catch(error => {
        if (error && error.message && error.message !== 'Network Error') return;
        Swal.fire({
          titleText: 'Error',
          text: 'Thumbnail failed to load, please try again',
          icon: 'error'
        });
      });
  }
</script>

<section class="flex w-full flex-col justify-between rounded-xl bg-zinc-100 p-4 lg:max-w-[240px]">
  <p class="text-base leading-6 text-zinc-700">
    {@html quote}
  </p>
  <div class="mt-3.5 flex items-center justify-between gap-10">
    <div class="my-auto flex items-center gap-3 self-stretch text-gray-400">
      <button class="hover:text-rose-500" use:tooltip={'Copy'} on:click={() => navigator.clipboard.writeText(quote)}>
        <i class="fa-solid fa-copy"></i>
      </button>
      <button
        class="hover:text-rose-500"
        use:tooltip={'Share to X'}
        on:click={() => {
          const twitterUrl = `https://x.com/intent/tweet?text=${encodeURIComponent(quote)}`;
          window.open(twitterUrl, '_blank');
        }}
      >
        <i class="fa-brands fa-x-twitter"></i>
      </button>
    </div>
    {#if !$isMobile}
      <button
        on:click={createNewClip}
        class="hoversermonbg my-auto min-h-[30px] gap-1.5 self-stretch rounded-md bg-rose-500 px-3 py-2 text-sm font-semibold text-white"
      >
        Make Image
      </button>
    {/if}
  </div>
</section>
